import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { setUcfirst } from '../../../handlers/helpers';

const PreviewLanguages = ({ items }) => {

  return (
      <Box className='contentBox'>
            {Object.values(items).map((item) => {
                return (
                  <Text className='subSections'>
                    <Box >
                      <Text >{setUcfirst(item.proficiency)} {item.language} </Text>
                    </Box>
                  </Text>
                );
              },
            )}
      </Box>
    );
};
export default PreviewLanguages;
